import React from 'react';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/Button'; // Import custom styles

const Button = ({ label, onClick, type = 'button', variant = 'primary', customClass = '', disabled = false }) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${customClass}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']),
  customClass: PropTypes.string, // Accept additional custom class names
  disabled: PropTypes.bool,
};

export default Button;
